"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var Cell = function (props) {
    var onCellClick = props.onCellClick, onCellEnter = props.onCellEnter, onCellLeave = props.onCellLeave, content = props.content, data = props.data;
    return (React.createElement("div", { className: "cell-data-wrap", onClick: onCellClick ? function () { return onCellClick(data); } : undefined, onMouseEnter: onCellEnter ? function () { return onCellEnter(data); } : undefined, onMouseLeave: onCellLeave ? function () { return onCellLeave(data); } : undefined }, content));
};
exports.default = Cell;
//# sourceMappingURL=Cell.js.map